Postlogin.Admin = Postlogin.Admin || {};
Postlogin.Admin.Lessons = Postlogin.Admin.Lessons || {};
Postlogin.Admin.Lessons.Activities = Postlogin.Admin.Lessons.Activities || {};

Postlogin.Admin.Lessons.Activities.Options = (function () {
    const init = function () {
        if ($('#hotspot-image-canvas').length) {
            let canvas;
            let ctx;
            const img = new Image();

            img.onload = function () {
                // eslint-disable-next-line prefer-destructuring
                canvas = $('#hotspot-image-canvas')[0];
                ctx = canvas.getContext('2d');

                ctx.lineWidth = 2;
                ctx.strokeStyle = '#ff0';
                ctx.lineCap = 'round';

                let points = [];
                let isDown = false;
                let last;

                canvas.onmousedown = function (e) {
                    const pos = getXY(e);
                    last = pos;
                    points = [];
                    isDown = true;
                    points.push(pos);
                    bg();
                };

                canvas.onmousemove = function (e) {
                    if (!isDown) return;

                    const pos = getXY(e);
                    points.push(pos);

                    ctx.beginPath();
                    ctx.moveTo(last.x, last.y);
                    ctx.lineTo(pos.x, pos.y);
                    ctx.stroke();

                    last = pos;
                };

                canvas.onmouseup = function () {
                    if (!isDown) return;

                    isDown = false;

                    minMax();
                };

                bg();

                const topleftX = $('#answer').val();
                const topleftY = $('#answer_es').val();
                const bottomrightX = $('#hint').val();
                const bottomrightY = $('#hint_es').val();

                if (topleftX > 0 && bottomrightX > 0 && topleftY > 0 && bottomrightY > 0) {
                    const oldMinX = canvas.width * (topleftX / 100);
                    const oldMinY = canvas.height * (topleftY / 100);
                    const oldMaxX = canvas.width * (bottomrightX / 100);
                    const oldMaxY = canvas.height * (bottomrightY / 100);
                    const lw = ctx.lineWidth;
                    const ss = ctx.strokeStyle;
                    ctx.lineWidth = 4;

                    ctx.strokeStyle = '#c00';
                    ctx.setLineDash([5, 10]);
                    ctx.strokeRect(oldMinX, oldMinY, oldMaxX - oldMinX, oldMaxY - oldMinY);
                    ctx.lineWidth = lw;
                    ctx.strokeStyle = ss;
                    ctx.setLineDash([]);
                }

                function bg() {
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(
                        img,
                        0,
                        0,
                        img.width,
                        img.height, // source rectangle
                        0,
                        0,
                        canvas.width,
                        canvas.height,
                    ); // destination rectangle
                }

                function minMax() {
                    let minX = 1000000;
                    let minY = 1000000;
                    let maxX = -1000000;
                    let maxY = -1000000;
                    let i = 0;
                    let p;
                    const lw = ctx.lineWidth;
                    const ss = ctx.strokeStyle;

                    // eslint-disable-next-line no-cond-assign
                    for (; (p = points[i++]);) {
                        if (p.x > maxX) maxX = p.x;
                        if (p.y > maxY) maxY = p.y;
                        if (p.x < minX) minX = p.x;
                        if (p.y < minY) minY = p.y;
                    }

                    ctx.lineWidth = 4;
                    ctx.strokeStyle = '#c00';
                    ctx.setLineDash([5, 10]);
                    ctx.strokeRect(minX, minY, maxX - minX, maxY - minY);
                    ctx.lineWidth = lw;
                    ctx.strokeStyle = ss;
                    ctx.setLineDash([]);
                    $('#answer').val((minX / canvas.width) * 100);
                    $('#answer_es').val((minY / canvas.height) * 100);
                    $('#hint').val((maxX / canvas.width) * 100);
                    $('#hint_es').val((maxY / canvas.height) * 100);
                }
            };
            img.src = $('#hotspot-image-canvas').attr('data-image-path');

            // eslint-disable-next-line no-inner-declarations
            function getXY(e) {
                const rect = canvas.getBoundingClientRect();
                const coords = { x: e.clientX - rect.left, y: e.clientY - rect.top };
                return coords;
            }
        }
    };

    return {
        init,
    };
}());
